import gql from "graphql-tag";
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import EXPENSE_REPORT from "../../graphql/ExpenseReport.gql";
import UPDATE_EXPENSE_REPORT from "../../graphql/UpdateExpenseReport.gql";
import CREATE_EXPENSE_REPORT from "../../graphql/CreateExpenseReport.gql";
import UPDATE_EXPENSE_REPORT_CHAT from "../../graphql/UpdateExpenseReportChat.gql";
import CREATE_TAG from "@/graphql/tag/CreateTag.gql";

import { UserActivity } from "../../services/userActivityServices";
import { ComponentBase } from "../ComponentBase";
import { getDBFormattedDate } from "@/services/dateServices";
import { User } from "../../store/store";
import { getConnectAccountableAccount } from "../../services/accountableAccountServices";
import { Component, Vue } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Document_type } from "../../../../types/types/indexTypes";
import { TravelExpense } from "../../../../backend/src/common/types/expenseReport";

@Component({
    emits: ["modified", "created"],
})
export class ExpenseReportBase extends ComponentBase {
    @Prop({ default: "Router" }) mode: string;
    @Prop({ default: false }) Mode: boolean;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) id: string;
    // allStatus = [
    //     { value: "EDITION", text: " En cours d'édition" },
    //     {
    //         value: "PENDING_DOCUMENTS_VALIDATION",
    //         text: "Des documents sont en cours de traitement"
    //     },
    //     { value: "PENDING_VALIDATION", text: "En attente de validation" },
    //     { value: "VALIDATED", text: "Validé" }
    // ];
    // @Prop({ default: "" }) id;

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    open_chat = false;

    inShowMessage = false;

    wishStatus: string = "";

    getChatSubTitle() {
        if (this.wishStatus === "DENIED") return "Raison de refus";
        if (this.wishStatus === "INFORMATION_REQUEST") return "Demande d'information";
        return "Réponse";
    }

    get year() {
        // ** year = millésime de la note de frais
        // ** exemple : en mars/avril 2025 sors le millésime 2025 applicable aux frais km de 2024
        // ** en conséquence, les ndf de 2024, saisies courant 2024, faute de disponibilité du barème applicable, seront calculées avec le barème 2024
        // ** les ndf de 2024, saisie après la publication du barème 2025, seront calculées avec le barème 2025
        // ** Il faudra concevoir un contrôle dans le Dossier de révision, afin de corriger les ndf de 2024 saisies avant la publication du barème 2025, de façon globale (annuelle), mais par collaborateur

        // ** Si déjà validé
        if (this.expenseReport.status === "VALIDATED" && this.expenseReport.year) {
            return this.expenseReport.year;
        }
        // ** Si en cours de saisie ou en édition
        const yearPlusOne = +moment(this.expenseReport.date).add(1, "years").format("YYYY");
        return yearPlusOne;
    }

    get openChat() {
        if (this.expenseReport.chat) {
            return true;
        }
        return this.open_chat;
    }

    setOpenChat(reason) {
        if (!this.open_chat) {
            this.open_chat = true;
        }
        this.wishStatus = reason;
    }

    async onMessageSent(data) {
        let update = false;
        const variables: any = {
            id: this.expenseReport.id,
            chat: undefined,
        };
        if (this.wishStatus) {
            variables.status = this.wishStatus;
            update = true;
            this.wishStatus = undefined;
        }
        if (!this.expenseReport.chat) {
            variables.chat = { connect: { id: data.chatId } };
            this.expenseReport.chat = { id: data.chatId };
            update = true;
        } else if (this.expenseReport.chat.id !== data.chatId) {
            debugger;
        }
        if (update) {
            await this.$apollo.mutate({
                mutation: UPDATE_EXPENSE_REPORT_CHAT,
                variables: variables,
            });
        }
    }

    onShowMessageChanged(data) {
        this.inShowMessage = data;
        this.wishStatus = undefined;
    }

    isModifiedByUser = false;

    /** Liste des categories possible les factures */
    get categories() {
        return [
            { text: "Carburant", value: "606120" },
            { text: "Fournitures / documentation", value: "606300" },
            { text: "Frais de déplacement", value: "625100" },
            { text: "Internet", value: "626200" },
            { text: "Poste", value: "626000" },
            { text: "Restaurant", value: "625700" },
            { text: "Téléphone", value: "626100" },
            ...this.categoriesToAdd,
        ];
    }

    document;
    categoriesToAdd = [];

    refuse = false;

    // date: string = moment().format("YYYY-MM-DD");

    menu = false;

    skipOnModelChanged: boolean = false;

    activity: any;

    onDateChanged(date) {
        this.expenseReport.date = date;
    }

    onBlur(e) {
        if (!e) {
            this.changeNameInput = false;
        }
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    getCategoryText(accountableAccount) {
        if (accountableAccount.name) {
            const foundCategory = this.categories.find(
                (category) => category.value === accountableAccount.name,
            );
            if (foundCategory) {
                return foundCategory.text;
            }
            if (accountableAccount.description) {
                return accountableAccount.description;
            }
        }
        return "Non défini";
    }

    getCategoryStyle(accountableAccount) {
        // let style = this.$vuetify.display.mobile ? 'font-weight: bold; font-size: 12pt;' : 'cursor: pointer;'
        let style = "";
        if (!accountableAccount || accountableAccount.name.startsWith("600000"))
            style += "color:red;";
        return style;
    }

    getCategoryTextFromName(accountableAccount) {
        if (accountableAccount) {
            const foundCategory = this.categories.find(
                (category) => category.value === accountableAccount,
            );
            if (foundCategory) {
                return foundCategory.text;
            }
        }
        return "";
    }

    /** Header du tableau des factures */
    get headers() {
        const headers: Array<any> = [
            { text: "Document", value: "", align: "center", sortable: false },
            // { text: "Statut", value: "", align: "center", sortable: true },
            { text: "Date", value: "", align: "center", sortable: false },
            { text: "Montant (HT)", value: "amount", align: "center", sortable: true },
            { text: "Montant (TTC)", value: "amount", align: "center", sortable: true },
            { text: "Categorie", value: "", align: "center", sortable: true },
        ];
        if (this.commonEnableModification) {
            headers.push({
                text: "Supprimer",
                value: "",
                align: "center",
                sortable: false,
            });
        }
        return headers;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    fix2(value) {
        return mathFix(value);
    }

    _mounted() {
        this.initializeUserActivity();
    }

    @Apollo({
        query() {
            return EXPENSE_REPORT;
        },
        // loadingKey: "loading",
        fetchPolicy: "network-only",
        variables() {
            return {
                id: this.expenseReportId,
            };
        },
        skip() {
            return !this.expenseReportId || this.skipOnModelChanged;
        },
        specificResult({ data, loading, networkStatus }: any) {
            // this.loading = loading;
            if (!loading) {
                if (data) {
                    if (data.expenseReport) {
                        // data.expenseReport.documents.forEach((document) => {
                        for (const document of data.expenseReport.documents) {
                            if (!document.accountableAccount || !document.accountableAccount.name) {
                                document.accountableAccount = {
                                    name: "",
                                };
                            } else {
                                let categorieExiste = this.categories.find(
                                    (category) =>
                                        category.value === document.accountableAccount.name,
                                );

                                if (!categorieExiste) {
                                    this.categoriesToAdd.push({
                                        text: document.accountableAccount.description,
                                        value: document.accountableAccount.name,
                                    });
                                }
                            }
                        }
                    }
                    this.expenseReport = data.expenseReport;
                    this.expenseReport.date = data.expenseReport.date
                        ? moment(data.expenseReport.date).format("YYYY-MM-DD")
                        : moment().format("YYYY-MM-DD");
                    if (this.expenseReportId !== data.expenseReport.id) {
                        // this.createdExpenseReportId = data.expenseReport.id
                        debugger;
                    }
                    // this.subscribe()
                    this.addListener("document");
                } else {
                    debugger;
                    this.expenseReport = null;
                }
            }
        },
    })
    expenseReport: any = {
        id: "",
        name: "",
        documents: [],
        user: {
            lastname: "",
            firstname: "",
            id: "",
        },
        status: "EDITION",
        chat: null,
        date: moment().format("YYYY-MM-DD"),
        amount: 0,
        year: 0,
    };

    beforeDestroy() {
        this.removeListener();
    }

    onMessage(data) {
        if (this.expenseReport?.documents?.length) {
            const index = this.expenseReport.documents.findIndex((doc) => doc.id === data.id);
            if (index !== -1) {
                this.expenseReport.documents.splice(index, 1, data.payload);
            }
        }
    }

    refresh() {
        if (this.$apollo.queries.expenseReport) {
            this.$apollo.queries.expenseReport.refetch();
        }
    }

    /** Variable d'affichage du tableau d'importation d'une note de frais */
    activeUploadDocuments = false;

    activeTravelExpense = false;

    /** Variable d'édition du nom de la note de frais */
    changeNameInput = false;

    currentTravelExpenseDocument = null;

    currentTravelExpense: TravelExpense = {
        version: 1,
        year: 0,
        vehiculeType: "CAR",
        power: 1,
        distance: 0,
        origin: {
            wordingAddress: "",
            latitude: null,
            longitude: null,
        },
        destination: {
            wordingAddress: "",
            latitude: null,
            longitude: null,
        },
        switchRoundTrip: false,
        electricalType: false,
    };

    createdExpenseReportId = "";

    get expenseReportId() {
        if (this.createdExpenseReportId) {
            return this.createdExpenseReportId;
        }
        return this.id;
    }

    /** Calcul du nombre de document validé */
    get nbrValidatedDocument() {
        const nbrValidatedDocument = this.expenseReport.documents.filter(
            (x) => x.status === "VALIDATED",
        ).length;
        return nbrValidatedDocument;
    }

    get totalAmount() {
        let totalAmount = 0.0;
        if (this.expenseReport.documents.length) {
            this.expenseReport.documents.forEach((doc) => {
                if (doc.grossAmount) {
                    totalAmount += doc.grossAmount;
                }
            });
            if (this.expenseReport.amount !== totalAmount) {
                this.expenseReport.amount = totalAmount;
                // this.save();
            }
        }
        return totalAmount;
    }
    // get totalAmount() {
    //     return this.expenseReport.amount
    // }

    get statusText() {
        if (this.expenseReport.status === "EDITION") {
            return "En édition par la personne";
        }
        if (this.expenseReport.status === "PENDING_DOCUMENTS_VALIDATION") {
            return "Traitement des docs par la personne";
        }
        if (this.expenseReport.status === "PENDING_VALIDATION") {
            return "À valider par le manager";
        }
        if (this.expenseReport.status === "VALIDATED") {
            return "Validé";
        }
        if (this.expenseReport.status === "DENIED") {
            return "Refusé";
        }
        if (this.expenseReport.status === "DELETED") {
            return "Supprimé";
        }
        if (this.expenseReport.status === "INFORMATION_REQUEST") {
            return "Demande d'information";
        }
        debugger;
        return "Unknown";
    }

    get status() {
        return this.expenseReport.status;
    }

    set status(status: string) {
        this.expenseReport.status = status;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get edition() {
        return this.expenseReport.status === "EDITION";
    }

    set edition(edition: boolean) {
        if (edition) {
            this.expenseReport.status = "EDITION";
        } else {
            this.checkDocumentStatus();
        }
    }

    get editionDisabled() {
        if (!this.expenseReport.documents || !this.expenseReport.documents.length) {
            return true;
        }
        for (const doc of this.expenseReport.documents) {
            if (
                !doc.accountableAccount ||
                doc.accountableAccount.name === "" ||
                doc.accountableAccount.name.startsWith("600000")
            ) {
                return true;
            }
        }
        return false;
    }

    get validated() {
        return this.expenseReport.status === "VALIDATED";
    }

    set validated(value: boolean) {
        if (value) {
            this.expenseReport.status = "VALIDATED";
        } else {
            this.checkDocumentStatus();
        }
    }

    checkDocumentStatus() {
        let newStatus = "PENDING_VALIDATION";
        for (const doc of this.expenseReport.documents) {
            if (doc.status !== "VALIDATED") {
                newStatus = "PENDING_DOCUMENTS_VALIDATION";
                break;
            }
        }
        this.expenseReport.status = newStatus;
    }

    getDateFormated(date) {
        if (date) {
            return moment(date).format("DD/MM/YYYY");
        }
        return "";
    }

    /** Variable d'ouverture d'un document */
    openDocument(document: any) {
        if (this.$vuetify.display.mobile) {
            if (document.travelExpense) {
                this.openTravelExpense(document);
            } else {
                this.openChangeAccountableAccountDialog(document);
            }
        } else {
            if (document.travelExpense) {
                this.openTravelExpense(document);
            } else {
                this.$router.push({
                    name: "document",
                    params: {
                        companyId: this.companyId,
                        id: document.id,
                    },
                });
            }
        }
    }

    accountableAccountDialog = false;
    selectedDocument_: any = {};

    get selectedDocument() {
        if (this.selectedDocument_ && this.selectedDocument_.id) {
            return this.selectedDocument_;
        }
        if (this.documents && this.documents.length) {
            return this.documents[0];
        }
        if (this.travelExpenses && this.travelExpenses.length) {
            return this.travelExpenses[0];
        }
        return null;
    }

    set selectedDocument(data) {
        this.selectedDocument_ = data;
    }

    get selectedTravelExpense() {
        return this.selectedDocument_.travelExpense;
    }

    set selectedTravelExpense(data) {
        this.selectedDocument_.travelExpense = data;
    }

    get travelExpenses() {
        return this.expenseReport.documents.filter((x) => x.travelExpense);
    }

    get documents() {
        return this.expenseReport.documents.filter((x) => !x.travelExpense);
    }

    get file() {
        return this.selectedDocument
            ? this.selectedDocument.workingCopy || this.selectedDocument.original
            : null;
    }

    get isPDF() {
        return this.file && this.file.type === "PDF";
    }

    get imageWidth() {
        return this.file ? this.file.width || 20.0 : 20.0;
    }

    get imageHeight() {
        return this.file ? this.file.height || 20.0 : 20.0;
    }

    openChangeAccountableAccountDialog(document) {
        this.accountableAccountDialog = true;
        this.selectedDocument = document;
    }

    /* Fonction de sauvegarde d'une note de frais */
    @Watch("changeNameInput")
    onChangeNameInput(val, prev) {
        //this.initializeUserActivity()
        if (val === false && prev === true) {
            this.save();
        }
    }

    initializeUserActivity() {
        this.activity = new UserActivity("CREATE", "EXPENSE_REPORT", moment());
    }

    async createUserActivity(expenseReportId, action) {
        await this.activity.create(
            this.$apollo,
            this.currentUser.id,
            this.companyId,
            expenseReportId,
            action,
        );
        this.initializeUserActivity();
    }

    async updateExpenseReport() {
        // Romain
        this.skipOnModelChanged = true;
        const save = await this.$apollo.mutate({
            mutation: UPDATE_EXPENSE_REPORT,
            variables: {
                id: this.expenseReport.id,
                name: this.expenseReport.name,
                date: getDBFormattedDate(this.expenseReport.date),
                status: this.expenseReport.status,
                userID: this.expenseReport.user.id,
                amount: this.totalAmount,
                documents: this.expenseReport.documents.map((document) => ({
                    id: document.id,
                })),
            },
        });
        this.skipOnModelChanged = false;
        this.$emit("modified");
        if (save) {
            try {
                await this.createUserActivity(this.expenseReport.id, "UPDATE");
            } catch (e) {
                console.error(e);
            }
        }
    }

    /**
     * Save new tags in the database
     */
    async persistNewTags(): Promise<void> {
        const newTags = this.selectedTags.filter((tag) => !tag.id);

        for (const tag of newTags) {
            const response = await this.$apollo.mutate({
                mutation: CREATE_TAG,
                variables: {
                    companyId: this.companyId,
                    name: tag.name,
                    primaryLog: Document_type.EXPENSE_REPORT,
                },
            });

            if (response.data?.createTag?.id) {
                tag.id = response.data.createTag.id; // Update tag id
            }
        }
    }

    async save(notify: boolean = false) {
        if (this.expenseReport.id !== "") {
            await this.updateExpenseReport();
            if (notify) {
                this.$emit("created");
            }
        } else {
            this.skipOnModelChanged = true;
            const documents = [];
            this.expenseReport.documents.forEach((document) => {
                documents.push({
                    id: document.id,
                });
            });

            await this.persistNewTags(); // Save new tags before saving expense report so that new tags can be connected
            const save = await this.$apollo.mutate({
                mutation: CREATE_EXPENSE_REPORT,
                variables: {
                    name: this.expenseReport.name,
                    date: getDBFormattedDate(this.expenseReport.date), // due to prisma 2 migration expected DateTime and '2021-11-14' is not a DateTime but a Date
                    status: this.expenseReport.status,
                    userID: this.expenseReport.user.id,
                    companyId: this.companyId,
                    amount: this.expenseReport.amount,
                    documents: documents,
                    tagIds: this.tagIds,
                },
            });
            if (save.data && save.data.createExpenseReport && save.data.createExpenseReport.id) {
                this.expenseReport.id = save.data.createExpenseReport.id;
                this.createdExpenseReportId = save.data.createExpenseReport.id;
                try {
                    await this.createUserActivity(this.expenseReport.id, "CREATE");
                } catch (e) {
                    console.error(e);
                }

                // this.expenseReport.chat.id = save.data.createExpenseReport.chat.id
                this.skipOnModelChanged = false;
                if (notify) {
                    this.$emit("created");
                }
            }
        }
    }

    get creator() {
        for (const doc of this.expenseReport.documents) {
            if (doc.user?.profile) {
                return doc.user;
            }
        }
        // if no doc user (retrocompatibility) we consider that creator is expenseReport user if expenseReport.user.id === this.currentUser.id
        if (this.expenseReport.user.id === this.currentUser.id) {
            return this.expenseReport.user;
        }
        return {
            firstname: "",
            lastname: "",
        };
    }

    get isCreator() {
        return this.creator.id === this.currentUser.id;
    }

    get isManager() {
        return this.currentUser?.profile?.configuration.expenseReport.validateWrite;
    }

    get disabledSubmit() {
        if (this.expenseReport.documents.length === 0) {
            return true;
        }
        for (let document of this.expenseReport.documents) {
            if (document.travelExpense) {
                if (!document.travelExpense.distance) return true;
            }
        }
        if (this.isAccountingUser) {
            for (let document of this.expenseReport.documents) {
                if (document.status !== "VALIDATED") {
                    return true;
                }
                if (
                    !document.accountableAccount ||
                    !document.accountableAccount.name ||
                    document.accountableAccount.name.startsWith("600000")
                ) {
                    if (
                        document.data &&
                        document.data.subAmounts?.length &&
                        !!document.data.subAmounts[0].accountableAccount
                    ) {
                        let accountableAccounts = document.data.subAmounts.map(
                            (x) => x.accountableAccount,
                        );
                        return accountableAccounts.some(
                            (x) => !x || !x.name || x.name.startsWith("600000"),
                        );
                    }
                    return true;
                }
            }
        }
        let status = this.expenseReport.status;
        switch (status) {
            case "EDITION": {
                if (this.isCreator) {
                    return false;
                }
                return true;
            }
            case "PENDING_VALIDATION": {
                if (this.isAccountingUser || this.isManager) {
                    return false;
                }
                return true;
            }
            case "PENDING_DOCUMENTS_VALIDATION": {
                if (this.isManager) {
                    return false;
                }
                return true;
            }
            case "VALIDATED": {
                return true;
            }
            case "DENIED": {
                return true;
            }
            case "DELETED": {
                return true;
            }
            case "INFORMATION_REQUEST": {
                return this.isCreator || this.isManager || this.isAccountingUser;
            }
        }

        if (this.isAccountingUser) {
            // if (this.expenseReport.documents.length === 0) return true;
            for (let document of this.expenseReport.documents) {
                if (document.travelExpense) {
                    if (!document.travelExpense.distance) return true;
                } else {
                    // if(!document.netAmount || !document.grossAmount || !document.vatAmount) return true;
                    if (document.status !== "VALIDATED") return true;
                    if (
                        !document.accountableAccount ||
                        !document.accountableAccount.name ||
                        document.accountableAccount.name.startsWith("600000")
                    ) {
                        return true;
                    }
                }
            }
        }
        if (this.expenseReport.status === "PENDING_VALIDATION") {
            return true;
        }

        return false;
    }

    get submitTitle() {
        // if (!this.commonEnableModification) {
        //     debugger // git-ignore
        //     return "XXX"
        // }
        if (this.currentUser.profile.configuration.expenseReport.validateWrite) {
            if (this.expenseReport.status === "VALIDATED") {
                return "Validé";
            }
            return "Valider";
        }
        return "Soumettre";
    }

    async submit() {
        const status: string =
            this.nbrValidatedDocument === this.expenseReport.documents.length
                ? this.currentUser.profile.configuration.expenseReport.validateWrite
                    ? "VALIDATED"
                    : "PENDING_VALIDATION"
                : "PENDING_DOCUMENTS_VALIDATION";
        this.expenseReport.status = status;
        this.updateExpenseReport();
    }

    /* Validation d'une note de frais */
    // valid() {
    //     this.expenseReport.status = 'PENDING_VALIDATION'
    //     this.save()
    // }

    async valid() {
        this.expenseReport.status = "VALIDATED";
        this.updateExpenseReport();
    }

    /* Connection d'un document a la note de frais */
    newDocument(document) {
        this.skipOnModelChanged = true;
        this.expenseReport.documents.push(document);
        this.skipOnModelChanged = false;
    }

    onFilesUploaded() {
        this.activeUploadDocuments = false;
    }

    async modifyTravelExpense() {
        if (this.currentTravelExpenseDocument) {
            this.currentTravelExpenseDocument.travelExpense = this.currentTravelExpense;
            this.currentTravelExpenseDocument.grossAmount = this.currentTravelExpenseAmount;

            this.skipOnModelChanged = true;
            const result = await this.$apollo.mutate({
                mutation: gql`
                    mutation updateExpenseReport(
                        $expenseReportId: ID!
                        $documentId: ID!
                        $travelExpense: Json
                        $amount: Float
                        $grossAmountSigned: Float
                    ) {
                        updateExpenseReport(
                            where: { id: $expenseReportId }
                            data: {
                                status: EDITION
                                documents: {
                                    update: {
                                        where: { id: $documentId }
                                        data: {
                                            travelExpense: $travelExpense
                                            netAmount: $amount
                                            netAmountSigned: $amount
                                            grossAmount: $amount
                                            grossAmountSigned: $grossAmountSigned
                                        }
                                    }
                                }
                            }
                        ) {
                            id
                        }
                    }
                `,
                variables: {
                    expenseReportId: this.expenseReport.id,
                    documentId: this.currentTravelExpenseDocument.id,
                    travelExpense: this.currentTravelExpense,
                    amount: this.currentTravelExpenseAmount,
                    grossAmountSigned: -this.currentTravelExpenseAmount,
                },
            });
            if (result) {
                this.activeTravelExpense = false;
                try {
                    await this.createUserActivity(this.expenseReport.id, "UPDATE");
                } catch (e) {
                    console.error(e);
                }
            }
            this.skipOnModelChanged = false;
        }
    }

    async categoryChange(document: any) {
        this.skipOnModelChanged = true;
        const result = await this.$apollo.mutate({
            mutation: gql`
                mutation updateDocument(
                    $documentId: ID!
                    $accountableAccountTableId: ID!
                    $acc: String!
                ) {
                    updateDocument(
                        where: { id: $documentId }
                        data: {
                            accountableAccount: {
                                connect: {
                                    uniqueName: {
                                        name: $acc
                                        accountableAccountTableId: $accountableAccountTableId
                                    }
                                }
                            }
                        }
                    ) {
                        id
                    }
                }
            `,
            variables: {
                documentId: document.id,
                acc: document.accountableAccount.name,
                accountableAccountTableId:
                    this.$store.state.accountableAccountTable?.id || undefined,
            },
        });
        try {
            await this.createUserActivity(this.expenseReport.id, "UPDATE");
        } catch (e) {
            console.error(e);
        }
        // if (result && result.data && result.data.updateDocument) {
        //     if (this.expenseReport.status !== "EDITION") {
        //         await this.$apollo.mutate({
        //             mutation: gql`
        //                 mutation updateExpenseReport(
        //                     $expenseReportId: ID!
        //                 ) {
        //                     updateExpenseReport(
        //                         where: { id: $expenseReportId }
        //                         data: {
        //                             status: EDITION
        //                         }
        //                     ) {
        //                         id
        //                     }
        //                 }
        //             `,
        //             variables: {
        //                 expenseReportId: this.expenseReport.id,
        //             }
        //         });
        //     }
        // }
        this.skipOnModelChanged = false;
    }

    async newTravelExpense() {
        if (this.expenseReport.id === "") {
            await this.save();
        }
        let expenseReportAmount = this.currentTravelExpenseAmount;
        this.expenseReport.documents.forEach((doc) => {
            if (doc.grossAmount) {
                expenseReportAmount += doc.grossAmount;
            }
        });
        if (this.expenseReport.id !== "") {
            this.skipOnModelChanged = true; //
            const aaConnect = await getConnectAccountableAccount(
                this.$store,
                this.$apollo,
                "625100",
            );
            const result = await this.$apollo.mutate({
                mutation: gql`
                    mutation updateExpenseReport(
                        $expenseReportId: ID!
                        $userId: ID!
                        $ownerId: ID!
                        $companyId: ID!
                        $aaConnect: AccountableAccountCreateOneInput!
                        $travelExpense: Json
                        $amount: Float
                        $amountSigned: Float
                        $expenseReportAmount: Float
                        $date: DateTime
                    ) {
                        updateExpenseReport(
                            where: { id: $expenseReportId }
                            data: {
                                amount: $expenseReportAmount
                                documents: {
                                    create: {
                                        name: "Frais de déplacement"
                                        type: EXPENSE_REPORT_DOCUMENT
                                        useForReconciliation: false
                                        status: VALIDATED
                                        owner: { connect: { id: $ownerId } }
                                        user: { connect: { id: $userId } }
                                        company: { connect: { id: $companyId } }
                                        accountableAccount: $aaConnect
                                        travelExpense: $travelExpense
                                        netAmount: $amount
                                        netAmountSigned: $amount
                                        grossAmount: $amount
                                        grossAmountSigned: $amountSigned
                                        date: $date
                                    }
                                }
                            }
                        ) {
                            id
                            documents {
                                id
                                name
                                status
                                date
                                travelExpense
                                accountableAccount {
                                    name
                                    description
                                }
                                grossAmount
                                grossAmountSigned
                            }
                        }
                    }
                `,
                variables: {
                    expenseReportId: this.expenseReport.id,
                    ownerId: this.expenseReport.user.id,
                    userId: this.currentUser.id,
                    companyId: this.companyId,
                    // accountableAccountTableId: this.$store.state.accountableAccountTable?.id || undefined,
                    aaConnect,
                    travelExpense: this.currentTravelExpense,
                    amount: this.currentTravelExpenseAmount,
                    amountSigned: -this.currentTravelExpenseAmount,
                    expenseReportAmount: expenseReportAmount,
                    date: getDBFormattedDate(this.expenseReport.date),
                    origin: this.currentTravelExpense.origin,
                    destination: this.currentTravelExpense.destination,
                    distance: this.currentTravelExpense.distance,
                    switchRoundTrip: this.currentTravelExpense.switchRoundTrip,
                },
            });
            if (result && result.data && result.data.updateExpenseReport.documents) {
                const newDoc = result.data.updateExpenseReport.documents.find(
                    (childDoc) =>
                        !this.expenseReport.documents.find((prevDoc) => childDoc.id === prevDoc.id),
                );
                if (newDoc) {
                    this.expenseReport.documents.push(newDoc);
                }
            }
            try {
                await this.createUserActivity(this.expenseReport.id, "UPDATE");
            } catch (e) {
                console.error(e);
            }
            this.activeTravelExpense = false;
            this.skipOnModelChanged = false;
        }
    }

    /** Suppression d'un document */
    async deleteDocument(documentIdument: string) {
        if (this.expenseReport.id !== "") {
            this.skipOnModelChanged = true;
            const result = await this.$apollo.mutate({
                mutation: gql`
                    mutation updateExpenseReport($documentId: ID!, $expenseReportId: ID!) {
                        updateExpenseReport(
                            where: { id: $expenseReportId }
                            data: { status: EDITION, documents: { delete: { id: $documentId } } }
                        ) {
                            id
                        }
                    }
                `,
                variables: {
                    documentId: documentIdument,
                    expenseReportId: this.expenseReport.id,
                },
            });
            if (result) {
                try {
                    await this.createUserActivity(this.expenseReport.id, "UPDATE"); // "DELETE"
                } catch (e) {
                    console.error(e);
                }
                const index = this.expenseReport.documents.findIndex(
                    (document) => document.id === documentIdument,
                );
                if (index >= 0 && index < this.expenseReport.documents.length) {
                    this.expenseReport.documents.splice(index, 1);
                }
            }
            this.skipOnModelChanged = false;
        }
    }

    setVehiculeType(type) {
        if (this.commonEnableModification) {
            this.currentTravelExpense.vehiculeType = type;
            if (type === "CAR") {
                if (this.currentTravelExpense.power === undefined) {
                    this.currentTravelExpense.power = 1;
                }
            } else if (type === "TWO_REAR_WHEELS_GT_50") {
                if (this.currentTravelExpense.power === undefined) {
                    this.currentTravelExpense.power = 1;
                }
            } else if (type === "TWO_REAR_WHEELS_LTE_50") {
                if (this.currentTravelExpense.power !== undefined) {
                    this.currentTravelExpense.power = 1;
                }
            }
        }
    }

    setPower(power) {
        if (this.commonEnableModification) this.currentTravelExpense.power = power;
    }

    // Automobile
    // Puissance fiscale	Jusqu'à 5000 km	De 5001 à 20000 km	Au-delà de 20000 km
    // 3 CV et moins	d x 0.451	(d x 0.270) + 906	d x 0.315
    // 4 CV	d x 0.518	(d x 0.291) + 1136	d x 0.349
    // 5 CV	d x 0.543	(d x 0.305) + 1188	d x 0.364
    // 6 CV	d x 0.568	(d x 0.32) + 1244	d x 0.382
    // 7 CV et plus	d x 0.595	(d x 0.337) + 1288	d x 0.401

    // 2 roues > 50 cm3
    // Scooters, motocyclettes (au-delà de 50 cm3)
    // Puissance fiscale	Jusqu'à 3000 km	De 3001 à 6000 km	Au-delà de 6000 km
    // 1 ou 2 CV	d x 0.338	(d x 0.084) + 760	d x 0.211
    // 3,4 ou 5 CV	d x 0.400	(d x 0.07) + 989	d x 0.235
    // Plus de 5 CV	d x 0.518	(d x 0.067) + 1351	d x 0.292

    // Vélomoteurs, cyclomoteurs (jusqu'à 50 cm3)
    // Jusqu'à 2000 km	De 2001 à 5000 km	Au-delà de 5000 km
    // d x 0.269	(d x 0.063) + 412	d x 0.146

    get currentTravelExpenseAmount() {
        if (!this.currentTravelExpense.distance) {
            return 0;
        }
        let travelExpenseTable = this.travelExpenseCal(
            +moment(this.expenseReport.date).format("YYYY"),
        );
        let result = {
            travelExpenseAmount: 0,
            coef: 0,
            fixAmount: 0,
        };
        let distance = this.currentTravelExpense.distance;
        if (this.currentTravelExpense.switchRoundTrip) {
            distance = distance * 2;
        }
        if (travelExpenseTable !== null) {
            result = travelExpenseTable(
                this.currentTravelExpense.vehiculeType,
                this.currentTravelExpense.power,
                distance,
                this.currentTravelExpense.electricalType,
            );
            return Math.round(result.travelExpenseAmount * 100) / 100;
        } else {
            debugger;
            return 0;
        }
    }

    travelExpenseCal(year = null) {
        try {
            const travelExpense = require(
                "../../services/travelExpense/" + year + "-travelExpense",
            );
            return travelExpense.default;
        } catch (e) {
            if (year > 2018) {
                return this.travelExpenseCal(year - 1);
            }
        }
        return null;
    }

    openTravelExpense(document) {
        this.currentTravelExpense = JSON.parse(JSON.stringify(document.travelExpense));
        this.currentTravelExpenseDocument = document;
        this.activeTravelExpense = true;
    }

    get commonEnableModification() {
        if (this.currentUser.profile.configuration.expenseReport.writeOnlySelf) {
            if (this.currentUser.id !== this.expenseReport.user.id) {
                return false;
            }
        }
        return this.currentUser.profile.configuration.expenseReport.write;
    }

    get expenseReportUser() {
        if (this.expenseReport && this.expenseReport.user) {
            return `${this.expenseReport.user.firstname} ${this.expenseReport.user.lastname}`;
        }
        return "";
    }

    get expenseReportUserId() {
        if (this.expenseReport && this.expenseReport.user) {
            return this.expenseReport.user.id;
        }
        return "";
    }

    createBottomToolbar() {
        return (
            this.currentUser.profile.configuration.expenseReport.validateWrite &&
            (this.expenseReport.status === "PENDING_VALIDATION" ||
                this.expenseReport.status === "DENIED" ||
                this.expenseReport.status === "INFORMATION_REQUEST")
        );
    }

    get showDetail() {
        if (!this.id) {
            return false;
        }
        if (this.expenseReport?.status === "VALIDATED") {
            return true;
        }
        return false;
    }

    setOrigin(origin) {
        if (this.commonEnableModification) {
            this.currentTravelExpense.origin = origin;
        }
    }

    setDestination(destination) {
        if (this.commonEnableModification) {
            this.currentTravelExpense.destination = destination;
        }
    }

    //
    // tag
    //
    selectedTags: { id: string; name: string; [key: string]: string }[] = [];

    get tagIds() {
        return this.selectedTags ? this.selectedTags.map((t) => ({ id: t.id })) : [];
    }

    onTagsChanged(data) {
        this.selectedTags = data.tags ?? [];
    }
}
